export enum GridType {
  SQUARE = 'square',
  HEX_POINTY = 'hex_pointy',
  HEX_FLAT = 'hex_flat',
  ISOMETRIC = 'isometric',
  BEZIER = 'bezier'
}

export interface GridTypeInfo {
  type: GridType;
  name: string;
  description: string;
}

export const GRID_TYPES: GridTypeInfo[] = [
  {
    type: GridType.SQUARE,
    name: 'Square Grid',
    description: 'Traditional square/rectangular grid'
  },
  {
    type: GridType.HEX_POINTY,
    name: 'Hex (Pointy Top)',
    description: 'Hexagonal grid with pointy tops'
  },
  {
    type: GridType.HEX_FLAT,
    name: 'Hex (Flat Top)',
    description: 'Hexagonal grid with flat tops'
  },
  {
    type: GridType.ISOMETRIC,
    name: 'Isometric',
    description: 'Diamond-shaped isometric grid (like Unity isometric tilemap)'
  },
  {
    type: GridType.BEZIER,
    name: 'Bezier (Coons Patch)',
    description: 'Non-uniform grid defined by 4 boundary cubic Bezier curves'
  }
];
